import * as React from 'react';
import withStyles from 'react-jss';
import { SearchResult } from './TypesInDiscoverRates/SearchResult';
import VerticalChargeCard from './ColumnViewChargeListCards';
import { LINKING_STATUS } from './DiscoverRateUtils';
import { ChargeListCardsStyles } from './ChargeListCards.styles';

const styles = () => ({
  interSectDiv: {
    minHeight: '100px',
    marginBottom: '16px',
  },
});

interface IntersectChargeCardProps {
  classes: {
    [X in keyof ReturnType<typeof styles>]: string;
  };
  domSelector: string;
  searchResult: SearchResult;
  topResult: SearchResult;
  isItemPresent: {
    isLocalsPresent: boolean;
    activeKey: string;
    ffListMap: Record<string, { id: string; name: string; linkingStatus: LINKING_STATUS }>;
    handleNewInquiry: (disableFields?: boolean) => void;
    history: any;
  };
}

const StyledVerticalChargeCard = withStyles(ChargeListCardsStyles)(VerticalChargeCard);

const IntersectChargeCard: React.FC<IntersectChargeCardProps> = ({
  classes,
  domSelector,
  searchResult,
  topResult,
  isItemPresent,
}) => {
  return (
    <div className={classes.interSectDiv}>
      <StyledVerticalChargeCard
        data={searchResult}
        topResult={topResult}
        isItemPresent={isItemPresent}   
      />
    </div>
  );
};

export default withStyles(styles)(IntersectChargeCard);
